import React from "react";

function Select({ label, value, options, onChange }) {
  return (
    <div className="select is-fullwidth">
      <select onChange={onChange} value={value}>
        <option className={" has-text-weight-semibold"} defaultValue>
          {label}
        </option>
        {options.map((item, index) => (
          <option key={"opt" + index} value={item.value} label={item.label} />
        ))}
      </select>
    </div>
  );
}
export default Select;
